import { Palette } from "lucide-react";

import type { IPro014CampaignItem } from "@/@types/campaign";
import type { IGradeTarget } from "@/@types/campaign-grade";
import { Badge } from "@/components/ui/badge";

import { useCampaignItemGrades } from "../hooks/use-campaign-item-grades";
import { gradeTargetLabel, ITEM_GRADES_TITLE } from "./grade/grade-messages";

interface ItemGradesSectionProps {
  campaignCode: number;
}

export function ItemGradesSection({ campaignCode }: ItemGradesSectionProps): JSX.Element | null {
  const items: IPro014CampaignItem[] = useCampaignItemGrades(campaignCode);
  if (items.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="details-item-grades">
      <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
        <Palette className="w-4 h-4" />
        {ITEM_GRADES_TITLE}
      </div>
      <div className="rounded-lg p-3 bg-secondary/20 space-y-2">
        {items.map((item: IPro014CampaignItem) => (
          <div key={item.itemCode} className="flex flex-wrap items-center gap-2">
            <Badge variant="outline" className="font-mono">
              {item.itemCode}
            </Badge>
            {item.grades.map((grade: IGradeTarget) => (
              <span key={gradeTargetLabel(grade)} className="text-xs text-muted-foreground">
                {gradeTargetLabel(grade)}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
